import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { isConfigFlagEnabled } from '../../../config';
import { selectHasHoleCards } from '../../../redux/reducers/pokerReducer';
import { selectSideBettingState } from '../../../redux/selectorFns';
import { useAppSelector } from '../../../redux/store';
import { HoleCardsControls } from './holeCardsControls';
import { PixiBetControlsRouter } from './pixi/pixiBetControlsRouter';
import { PixiSideBetButton } from './pixi/pixiSideBetButton';
import { PixiSitInButton } from './pixi/pixiSitInButton';
import { PokerGameControlsBackground } from './pokerGameControlsBackground';
function getControlsContents(sitInButtonBounds, sideBetButtonBounds, sideBettingState, isSelfSittingOut) {
    if (isSelfSittingOut) {
        if (isConfigFlagEnabled('domBetButtons')) {
            return null;
        }
        if (!sitInButtonBounds) {
            return null;
        }
        return _jsx(PixiSitInButton, { bounds: sitInButtonBounds });
    }
    if (sideBettingState === 'available') {
        if (isConfigFlagEnabled('domBetButtons')) {
            return null;
        }
        if (!sideBetButtonBounds) {
            return null;
        }
        return _jsx(PixiSideBetButton, { bounds: sideBetButtonBounds });
    }
    return _jsx(PixiBetControlsRouter, {});
}
export const PokerGameControls = () => {
    const tableAreaDimensions = useAppSelector((state) => state.gameDimensions.tableAreaDimensions, shallowEqual);
    const holeCardsAreaDimensions = useAppSelector((state) => state.gameDimensions.holeCardsAreaDimensions, shallowEqual);
    const gameControlsDimensions = useAppSelector((state) => state.gameDimensions.gameControlsDimensions, shallowEqual);
    const sideBettingState = useAppSelector(selectSideBettingState);
    const isSelfSittingOut = useAppSelector((state) => state.poker.isSelfSittingOut);
    const hasHoleCards = useAppSelector(selectHasHoleCards);
    const sitInButtonBounds = useAppSelector((state) => state.gameDimensions.sitInButtonBounds, shallowEqual);
    const sideBetButtonBounds = useAppSelector((state) => state.gameDimensions.sideBetButtonBounds, shallowEqual);
    if (!tableAreaDimensions || !gameControlsDimensions || !holeCardsAreaDimensions) {
        return null;
    }
    const showBackground = hasHoleCards || isSelfSittingOut || sideBettingState === 'available';
    return (_jsxs(_Fragment, { children: [showBackground ? (_jsx(PokerGameControlsBackground, { tableAreaDimensions: tableAreaDimensions, gameControlsDimensions: gameControlsDimensions })) : null, getControlsContents(sitInButtonBounds, sideBetButtonBounds, sideBettingState, isSelfSittingOut), _jsx(HoleCardsControls, { tableAreaDimensions: tableAreaDimensions, holeCardsAreaDimensions: holeCardsAreaDimensions, gameControlsDimensions: gameControlsDimensions })] }));
};
